(function() {
    console.log('----> TEST CUSTOM JS');
    const targetSidebarContainer = document.querySelector('.sidebar-container');

    function checkInertAndRemove() {
        console.log('checkInertAndRemove');

        const targetIubendaBanner = document.getElementById('iubenda-cs-banner');
        console.log('targetIubendaBanner', targetIubendaBanner);
        if (targetIubendaBanner?.hasAttribute('inert')) {
            targetIubendaBanner.removeAttribute('inert');
        }
    }

    if (targetSidebarContainer) {
        console.log('targetSidebarContainer', targetSidebarContainer);
        const configSidebarContainer = { attributes: true, childList: false, subtree: false };

		const callback = function(mutationsList, observerSidebarContainer) {
			console.log('test', mutationsList, observerSidebarContainer);
			checkInertAndRemove();
		};

		const observerSidebarContainer = new MutationObserver(callback);
		observerSidebarContainer.observe(targetSidebarContainer, configSidebarContainer);
    }
})();
